<template>
  <div class="form-control tiptap rounded-xl border p-4" :class="schema.fieldClasses">
    <span class="mb-3 flex gap-2 group-editor">
      <button type="button" @click="editor.chain().focus().toggleBold().run()">
        <i class="bx bx-bold me-1"></i>
      </button>
      <button type="button" @click="editor.chain().focus().toggleItalic().run()">
        <i class="bx bx-italic me-1"></i>
      </button>
      <button type="button" @click="editor.chain().focus().toggleUnderline().run()">
        <i class="bx bx-underline me-1"></i>
      </button>
    </span>

    <!-- TEXT ALIGN  -->
    <span class="mb-3 flex gap-2 group-editor">
      <button type="button" @click="editor.chain().focus().setTextAlign('left').run()">
        <i class="bx bx-align-left me-1"></i>
      </button>
      <button type="button" @click="editor.chain().focus().setTextAlign('center').run()">
        <i class="bx bx-align-center me-1"></i>
      </button>
      <button type="button" @click="editor.chain().focus().setTextAlign('right').run()">
        <i class="bx bx-align-right me-1"></i>
      </button>
    </span>

    <!-- LISTS  -->
    <span class="mb-3 flex gap-2 group-editor">
      <button type="button" @click="editor.chain().focus().toggleBulletList().run()">
        <i class="bx bx-list-ul me-1"></i>
      </button>
      <button type="button" @click="editor.chain().focus().toggleOrderedList().run()">
        <i class="bx bx-list-ol me-1"></i>
      </button>
    </span>


    <!-- IMAGE   -->
    <!-- <span class="mb-3 flex gap-2 group-editor">
      <button type="button" @click="editor.chain().focus().setImage({ src: 'https://placeimg.com/640/480/any' }).run()">
        <i class="bx bx-image me-1"></i>
      </button>
    </span> -->

    <EditorContent :editor="editor" class="tiptap min-h-[200px] outline-none" />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { EditorContent, Editor } from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";
import abstractField from 'vfg-next/src/fields/abstractField'
import Image from '@tiptap/extension-image'
import TextAlign from '@tiptap/extension-text-align'

export default defineComponent({
  name: "fieldTiptap",

  components: {
    EditorContent,
  },

  mixins: [abstractField],

  data() {
    return {
      editor: null,
    };
  },

  mounted() {
    this.editor = new Editor({
      content: this.value || "",

      extensions: [StarterKit.configure({
        heading: {
          levels: [1, 2, 3],
        },

        codeBlock: false,
      }),

        Image.configure({
          HTMLAttributes: {
            style: 'max-width:100%;height:auto;',
          },
        }),
        TextAlign.configure({ types: ['heading', 'paragraph'] }),
      ],

      onUpdate: ({ editor }) => {
        this.value = editor.getHTML();
      },
    });
  },

  beforeUnmount() {
    if (this.editor) {
      this.editor.destroy();
    }
  },

  watch: {
    value(value) {
      if (!this.editor) return;

      if (value !== this.editor.getHTML()) {
        this.editor.commands.setContent(value || "", false);
      }
    },
  },
});
</script>

<style>
.tiptap p {
  margin: 0.5rem 0;
}

.tiptap:focus {
  outline: none;
}
.tiptap img {
  max-width: min(100%, 400px);
  max-height: 400px;
  height: auto;
  object-fit: contain;
}
.tiptap .group-editor  {
  padding: 0.25rem 0.5rem;
  border-right: 1px solid #e5e7eb;
}
</style>
